import { useCallback, useEffect, useRef, useState } from 'react';
import { type LayoutChangeEvent } from 'react-native';
import {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated';

export const useOrderPlaybackCta = (props: UseOrderPlaybackCtaProps) => {
  const { fadeIn, animationDuration } = props;

  const ctaRef = useRef<any>(null);
  const [ctaWidth, setCtaWidth] = useState(0);
  const handleOnLayout = useCallback((event: LayoutChangeEvent) => {
    setCtaWidth(event.nativeEvent.layout.width);
  }, []);

  const animationProgress = useSharedValue(0);

  const backgroundAnimatedStyle = useAnimatedStyle(() => {
    return {
      width: interpolate(animationProgress.value, [0, 1], [0, ctaWidth]),
    };
  }, [ctaWidth]);

  useEffect(() => {
    if (ctaWidth === 0) return;

    animationProgress.value = withDelay(fadeIn, withTiming(1, { duration: animationDuration }));
  }, [ctaWidth, fadeIn, animationDuration, animationProgress]);

  return {
    ctaRef,
    handleOnLayout,
    backgroundAnimatedStyle,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseOrderPlaybackCtaProps = {
  fadeIn: number;
  animationDuration: number;
};
